const APPLICATION_NAME = 'IWC_LOGIN_APP_OTP';
const fncls = 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99';
const EMAIL = 'email';
const PASSWORD = 'password';
const detail = {
    type: APPLICATION_NAME,
    fields: [EMAIL, PASSWORD],
};
export const syncFieldName = 'fn_sync_data';
/**
 * Sets the config variables globally required by the async fraudnet script
 * @param {Object} options
 */
const injectConfig = (options = {}) => {
    var script = document.getElementById('fconfig');
    if (script && script.parentNode) {
        script.parentNode.removeChild(script);
    }
    script = document.createElement('script');
    script.id = 'fconfig';
    script.type = 'application/json';
    script.setAttribute('fncls', fncls);
    var configuration = {
        f: options.fnSessionId,
        s: options.sourceId,
        b: options.beaconUrl,
        ts: {
            type: options.sourceId,
            fields: [{ id: EMAIL, min: 6 }],
            delegate: false,
        },
    };
    script.text = JSON.stringify(configuration);
    document.body.appendChild(script);
};
/**
 * Initializes the script the fires the fraudnet beacon that will start collecting the fraudnet payload
 * @param {Object} options
 */
const loadBeaconJS = (options) => {
    const script = document.createElement('script');
    script.src = options.fnUrl || 'https://c.paypal.com/da/r/fb.js';
    script.onload = function () {
        // Use the server side flag to collect typing speed after the fraudnet beacon has loaded
        if (options.enableTypingSpeed && typeof initTsFb === 'function') {
            window.initTsFb({
                detail,
            });
        }
    };
    document.body.appendChild(script);
};
/**
 * Calls the above private functions required for async fraudnet with the config data passed from the server
 */
export const initializeAsync = (config = {}) => {
    const PAYPAL = window.PAYPAL || {};
    if (PAYPAL.asyncData && typeof PAYPAL.asyncData.initAndCollect === 'function') {
        return PAYPAL.asyncData.initAndCollect(); // retrigger
    }
    injectConfig(config);
    loadBeaconJS(config);
};
/**
 * Initializes the fraudnet sync with the config data passed from the server
 * Since it requires prior load of the sync script, we need to load it ourselves in IWC
 * hence this method also returns a Promise so that it can participate in `async/await` calls
 * that can happen during behind the scenes operations such as "lookup"
 */
export const initializeSync = (config = {}) => {
    const p = new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = 'https://www.paypalobjects.com/rdaAssets/fraudnet/sync/fn-sync-telemetry-min.js';
        script.crossOrigin = 'anonymous';
        script.onload = () => {
            const fnSyncDataInput = document.createElement('input');
            fnSyncDataInput.type = 'hidden';
            fnSyncDataInput.name = syncFieldName;
            fnSyncDataInput.id = syncFieldName;
            document.body.appendChild(fnSyncDataInput);
            const PAYPAL = window.PAYPAL || {};
            if (PAYPAL.syncData && PAYPAL.syncData.initSync) {
                PAYPAL.syncData.initSync({
                    fnSessionId: config.fnSessionId,
                    sourceId: config.sourceId,
                    fname: syncFieldName,
                    detail,
                });
            }
            resolve();
        };
        script.onerror = () => {
            // do not block script that "awaits" this method
            // this is done in order to be able to proceed with
            // Storybook based dev, stage level CORS issues or unit tests
            // where CORS might not allow this Fn file to be loaded
            resolve();
        };
        // Append the Fn script only on non unit test environments (denoted by http://localhost/)
        // This is done in order to avoid scripts tags to make network resources for their src values
        if (document.location.href !== 'http://localhost/') {
            document.body.appendChild(script);
        }
        else {
            // For Unit Test environment, the promise is resolved directly
            // so that scripts that await on this do not get blocked
            resolve();
        }
    });
    return p;
};
/**
 * Returns the the fraudnet sync data that gets flushed to the input element after data is collected
 */
export const getFnSyncPayload = () => {
    const PAYPAL = window.PAYPAL || {};
    if (PAYPAL.syncData && PAYPAL.syncData.flushData) {
        PAYPAL.syncData.flushData();
    }
    const fnSyncDataInput = document.querySelector('input[name=fn_sync_data]');
    if (fnSyncDataInput) {
        return encodeURIComponent(JSON.stringify({
            fn_sync_data: fnSyncDataInput.value,
        }));
    }
};
